'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Constants


var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _userConstants = require('./userConstants');

var _currentUserConstants = require('./currentUserConstants');

var _selectionConstants = require('../../common/elements/selectionConstants');

var _elementConstants = require('../../common/elements/elementConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = Immutable.Map({
    currentBoardId: null,
    timestamp: null,
    selectedElementIds: null
});

var updateUser = function updateUser(state, action) {
    var userChanges = Immutable.fromJS(action.changes);
    return state.mergeDeep(userChanges);
};

var setUser = function setUser(state, action) {
    return state.mergeDeep(Immutable.fromJS(action.user));
};

var updateActiveUserBoard = function updateActiveUserBoard(state, action) {
    var timestamp = action.modified || action.timestamp;
    return state.set('onlineStatus', _userConstants.USER_ONLINE_STATUS.CONNECTED).set('currentBoardId', action.newBoardId).set('timestamp', timestamp);
};

var updateActiveUserTimestamp = function updateActiveUserTimestamp(state, action) {
    var timestamp = action.modified || action.timestamp;
    return state.set('onlineStatus', _userConstants.USER_ONLINE_STATUS.CONNECTED).set('timestamp', timestamp);
};

var connectUser = function connectUser(state, action) {
    return state.set('onlineStatus', _userConstants.USER_ONLINE_STATUS.CONNECTED).set('timestamp', action.timestamp);
};

var disconnectUser = function disconnectUser(state, action) {
    return state.set('onlineStatus', _userConstants.USER_ONLINE_STATUS.DISCONNECTED).set('selectedElementIds', null);
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _userConstants.USER_UPDATE:
            return updateUser(state, action);
        case _userConstants.USER_REFRESH:
        case _currentUserConstants.CURRENT_USER_SET:
            return setUser(state, {
                user: _extends({}, action.user, {
                    onlineStatus: _userConstants.USER_ONLINE_STATUS.CONNECTED,
                    authenticated: true,
                    fetched: true
                })
            });
        case _userConstants.USER_NAVIGATE:
            return updateActiveUserBoard(state, action);
        case _elementConstants.ELEMENT_MOVE_MULTI:
        case _elementConstants.ELEMENT_UPDATE:
        case _selectionConstants.ELEMENTS_SELECTED:
        case _selectionConstants.ELEMENTS_DESELECTED:
            return updateActiveUserTimestamp(state, action);
        case _userConstants.USER_CONNECT:
            return connectUser(state, action);
        case _userConstants.USER_ACTIVITY_LOAD:
        case _userConstants.USER_DISCONNECT:
            return disconnectUser(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/userReducer.js
// module id = 2112
// module chunks = 0